import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ExtPlatDataRetrieveUseCase extends BaseUseCase {
    constructor(tex3AccountRetrive) {
        super();
        this.tex3AccountRetrive = tex3AccountRetrive;
    }
    async fetchResult(token) {
        return await this.tex3AccountRetrive.retriveAccountData(token);
    }
}
export default ExtPlatDataRetrieveUseCase;
